import React, { useState } from 'react';
import { isMobile, isMobileWithOutIpad } from '@helpers/EnvHelper';
import { isEmpty as _isEmpty } from 'lodash';
import SlideVideo from '@molecules/slider/SlideVideo';

/* 메인 키비쥬얼 타입:동영상등록 */
const VideoBanner = ({ data, onPlay, setOnPlay, setCurrentVideoRef }) => {
  let visualStyle = isMobileWithOutIpad() ? 'pt-[153.6%]' : 'pt-[56.25%]';

  return (
    <>
      <div className="relative z-20 w-full max-w-[1920px] max-h-[870px] overflow-hidden">
        <div className={visualStyle} />
        <div className="absolute top-0 left-0 flex flex-col justify-center items-center w-full h-full">
          <div className="w-full h-full absolute bg-black"></div>
          <div className="w-full h-full max-w-[1920px] relative z-20">
            <SlideVideo
              src={data.videoSrc}
              poster={
                isMobile() &&
                !_isEmpty(data.moImageSrc) &&
                data.moImageSrc.length > 1
                  ? data.moImageSrc
                  : data.imageSrc
              }
              onPlay={onPlay}
              setOnPlay={setOnPlay}
              setCurrentVideoRef={setCurrentVideoRef}
              bgBlackYN="Y"
            />
          </div>
        </div>
      </div>
      <div className="absolute w-full h-full overflow-hidden">
        <img
          src={`${data.imageSrc}`}
          alt=""
          className="blur-[50px] scale-110"
        />
        <div className="w-full h-full absolute bg-black top-0 left-0 opacity-50"></div>
      </div>
    </>
  );
};

export default VideoBanner;
